export default {
  creditStatistics: {
    search: {
      businessDepartment: '事业部门',
      businessDepartmentPlaceholder: '请选择事业部门',
      partnerType: '合作伙伴类型',
      partnerTypePlaceholder: '请选择合作伙伴类型',
      onlyShow: '只显示母公司额度',
      onlyShowPlaceholder: '请选择是否只显示母公司额度',
      partner: '合作伙伴名称/编码',
      partnerPlaceholder: '请输入合作伙伴名称/编码',
      creditCode: '信用账户号',
      creditCodePlaceholder: '请输入信用账户号',
    },
    table: {
      businessDepartmentName: '事业部门',
      referenceContractNo: '关联合同号',
      partnerType: '合作伙伴类型',
      partnerCode: '合作伙伴编码',
      partnerName: '合作伙伴名称',
      creditCode: '信用账户号',
      usedAmount: '已占用额度',
      hnYfKqOrderAmount: '可签合同信用额度',
      creditCodeDesc: '信用账户号描述',
      accountType: '账款类型',
      creditType: '授信类型',
      requestAmount: '可用信用额度(元)',
      validDate: '有效期从',
      invalidDate: '有效期到',
      availableAmount: '信用额度(元)',
      advanceCharge: '预付款(元)',
      supplierRefund: '供应商退款(元)',
      storageAmount: '入库金额(元)',
      deliveryAmount: '发货金额(元)',
      receivables: '收款(元)',
      salesRefund: '销售退款(元)',
      hnOrderAmount: '订单金额(海宁)',
      createPersonName: '创建人',
      gmtCreate: '创建时间',
      mark: '备注',
      supplierNo: '合作伙伴代码',
      supplierName: '合作伙伴名称',
      contractNo: '合同号',
      tradeTypeName: '合同类型',
      contractBusinessDepartmentName: '部门',
      contractCurrencyName: '币种',
      unpaidAmount: '未支付原币金额',
      unpaidCNYAmount: '未支付人民币金额',
    },
    detail: {
      partnerCode: '合作伙伴编码',
      partnerName: '合作伙伴名称',
      contractNo: '代理合同号',
      contractType: '合同类型',
      shops: '行号',
      partNo: '物料编号',
      partMark: '物料描述',
      number: '数量',
      unit: '单位',
      unitPrice: '单价',
      total: '总价',
      currency: '货币',
      department: '部门',
      homeCurrency: '本币金额总价',
      deposit: '保证金',
    },
  },
};
